import styled from 'styled-components';

interface bredcrumbProps {
	padding?: string;
	margin?: string;
}
const Bredcrumb = styled.div<bredcrumbProps>`
    margin: ${({ margin }) => margin}!important;
    padding: ${({ padding }) => padding}!important;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding:18px 24px 16px 0;
    white-space: nowrap;
    overflow: hidden;
    overflow-x: auto;
    }
`;

export default Bredcrumb;
